import { createStyles, makeStyles } from '@material-ui/core';

const useStyles = makeStyles(() => createStyles({
  tooltip: {
    backgroundColor: '#515B6A',
    fontSize: 12,
    maxWidth: 150,
  },
  label: {
    display: 'flex',
    alignItems: 'center',
  },
  icon: {
    display: 'flex',
    '& svg': {
      color: '#747C99',
      fontSize: 18,
      marginRight: 10,
    },
  },
  separator: {
    borderColor: '#DCDEE5',
    margin: 0,
  },
  mainButton: {
    whiteSpace: 'nowrap',

    '& span': {
      whiteSpace: 'nowrap',
    },
  },
}), { name: 'ButtonGroup' });

export default useStyles;
